/* Loja do Cabelo: purchase totals and colour/length refinement. */
(() => {
'use strict';

  function ldcPurchaseTotals(variant, quantity) {
    const q = Number(quantity);
    if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0 ||
        !Number.isSafeInteger(q) || q < 1) return null;
    const amount = variant.price * q;
    const grams = Number(variant.grams) || 0;
    const pieces = Number(variant.pieces) || 0;
    if (!Number.isSafeInteger(amount) || !Number.isSafeInteger(grams * q) || !Number.isSafeInteger(pieces * q)) return null;
    return { quantity: q, amount, grams, totalGrams: grams * q, pieces, totalPieces: pieces * q };
  }
  function ldcFacetValues(colour, length, title, colourNames = {}) {
    const rawColour = (colour || '').trim();
    const match = rawColour.match(/^#?(\d+[a-z]*(?:\/\d+[a-z]*)?)(?=\s|[.(—–-]|$)/i) ||
      (title || '').match(/\bcor\s*#?(\d+[a-z]*(?:\/\d+[a-z]*)?)(?=\s|$)/i);
    const color = match ? match[1].toLowerCase() : '';
    const rawDescription = color && rawColour ? rawColour.slice(match[0].length).replace(/^[\s.(—–:-]+/, '').replace(/[.)]+$/, '').trim() : '';
    const description = colourNames[color] || (rawDescription ? rawDescription.charAt(0).toLocaleUpperCase() + rawDescription.slice(1).toLocaleLowerCase() : '');
    const colourLabel = color ? '#' + color.toUpperCase() + (description ? ' — ' + description : '') : '';
    const size = (length || title || '').match(/(\d+)\s*(?:(?:a|[-–—])\s*(\d+)\s*)?cm\b/i);
    const sizeLabel = size ? size[1] + ' cm' : '';
    return { color, colourLabel, length: sizeLabel };
  }
  function ldcFacetMatches(record, selection) {
    return (!selection.color || record.color === selection.color) &&
      (!selection.length || record.length === selection.length);
  }

  if (!customElements.get('ldc-purchase-summary')) {
    customElements.define('ldc-purchase-summary', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.root = this.closest('[data-product-details], [data-ldc-color-product]');
        this.form = this.closest('form');
        if (!this.root || !this.form) return;
        try { this.data = JSON.parse(this.querySelector('[data-ldc-purchase-data]').textContent); }
        catch (_) { return; }
        this.ready = true;
        this.colour = this.querySelector('[data-ldc-purchase-colour]');
        this.detail = this.querySelector('[data-ldc-purchase-detail]');
        this.price = this.querySelector('[data-ldc-purchase-price]');
        this.detail.setAttribute('aria-live', 'polite');
        this.detail.setAttribute('aria-atomic', 'true');
        try { this.money = new Intl.NumberFormat(this.dataset.locale || 'pt-PT', {style: 'currency', currency: this.dataset.currency || 'EUR'}); }
        catch (_) { this.money = null; }
        this.schedule = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.sync(), 0); };
        this.onClick = event => { if (event.target.closest('[data-quantity-plus], [data-quantity-minus]')) this.schedule(); };
        this.root.addEventListener('input', this.schedule);
        this.root.addEventListener('change', this.schedule);
        this.root.addEventListener('variant-change', this.schedule, true);
        this.root.addEventListener('click', this.onClick);
        window.addEventListener('pageshow', this.schedule);
        window.addEventListener('popstate', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, {subtree: true, attributes: true, attributeFilter: ['variant']});
        this.sync();
      }
      sync() {
        if (!this.isConnected) return;
        const colour = this.form.querySelector('[data-color-variant]');
        const selector = this.form.querySelector('variant-selection');
        const fallback = this.form.querySelector('[name="id"]');
        const id = colour ? colour.value : selector ? selector.getAttribute('variant') : fallback ? fallback.value : this.dataset.initialVariant;
        const variant = this.data.variants[id];
        const field = this.form.querySelector('[name="quantity"]');
        const totals = ldcPurchaseTotals(variant, field ? field.value : 1);
        const labels = this.data.labels;
        if (this.colour) {
          const selectedColour = variant?.color || '';
          this.colour.textContent = selectedColour ? labels.color + ': ' + selectedColour : '';
          this.colour.hidden = !selectedColour;
        }
        this.hidden = false;
        if (!totals) {
          this.detail.textContent = variant ? labels.invalidQuantity : labels.choose;
          this.price.textContent = '';
          return;
        }
        const q = totals.quantity;
        if (totals.grams > 0 && totals.pieces > 0) {
          this.detail.textContent = q + ' ' + (q === 1 ? labels.packOne : labels.packMany) + ' · ' + totals.totalPieces + ' ' + labels.tapes + ' · ' + totals.totalGrams + ' g';
        } else if (totals.grams > 0) {
          this.detail.textContent = q + ' × ' + totals.grams + ' g = ' + totals.totalGrams + ' g';
        } else if (totals.pieces > 0) {
          this.detail.textContent = q + ' ' + (q === 1 ? labels.packOne : labels.packMany) + ' × ' + totals.pieces + ' = ' + totals.totalPieces + ' ' + labels.extensions;
        } else {
          this.detail.textContent = q + ' ' + (q === 1 ? labels.unitOne : labels.unitMany);
        }
        this.price.textContent = this.money ? this.money.format(totals.amount / 100) : (totals.amount / 100).toFixed(2) + ' ' + this.dataset.currency;
      }
      disconnectedCallback() {
        if (!this.ready) return;
        clearTimeout(this.timer);
        this.observer.disconnect();
        this.root.removeEventListener('input', this.schedule);
        this.root.removeEventListener('change', this.schedule);
        this.root.removeEventListener('variant-change', this.schedule, true);
        this.root.removeEventListener('click', this.onClick);
        window.removeEventListener('pageshow', this.schedule);
        window.removeEventListener('popstate', this.schedule);
        this.ready = false;
      }
    });
  }

  const ldcRefinements = new WeakMap();
  class LdcCatalogueRefinement {
    constructor(root, configNode, grid) {
      this.root = root;
      this.configNode = configNode;
      this.grid = grid;
      this.config = JSON.parse(configNode.textContent);
      this.labels = this.config.labels;
      this.originals = Array.from(grid.querySelectorAll('[data-ldc-card]'));
      this.records = [];
      this.clones = [];
      this.controls = Array.from(root.querySelectorAll('[data-ldc-refine-controls]'));
      this.forms = this.controls.map(control => control.closest('form'));
      this.status = root.querySelector('[data-ldc-refine-status]');
      this.count = root.querySelector('[data-ldc-refine-count]');
      this.pagination = root.querySelector('[data-ldc-refine-pagination]');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.controls.forEach(control => {
        control.hidden = false;
        control.querySelectorAll('select').forEach(select => select.addEventListener('change', () => {
          this.selection = {
            color: control.querySelector('[data-ldc-colour-select]').value,
            length: control.querySelector('[data-ldc-length-select]').value
          };
          this.syncControls();
          this.apply(true);
        }, {signal}));
        control.querySelector('[data-ldc-refine-retry]').addEventListener('click', () => this.load(), {signal});
      });
      this.root.querySelector('[data-ldc-refine-clear]')?.addEventListener('click', () => {
        this.selection = {color: '', length: ''};
        this.syncControls();
        this.apply(true);
      }, {signal});
      window.addEventListener('popstate', () => {
        if (!this.loaded) return;
        this.readSelection();
        this.syncControls();
        this.apply(false);
      }, {signal});
      this.load();
    }
    readSelection() {
      const params = new URL(window.location.href).searchParams;
      const requestedLength = params.get('ldc_length') || '';
      this.selection = {color: (params.get('ldc_color') || '').toLowerCase(), length: ldcFacetValues('', requestedLength, '').length || requestedLength};
    }
    message(text, failed) {
      this.controls.forEach(control => {
        control.querySelector('[data-ldc-refine-message]').textContent = text;
        control.querySelector('[data-ldc-refine-retry]').hidden = !failed;
      });
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.message(this.labels.loading, false);
      const fetchController = new AbortController();
      const abort = () => fetchController.abort();
      this.controller.signal.addEventListener('abort', abort, {once: true});
      const timeout = setTimeout(abort, 45000);
      try {
        const pages = new Map([[this.config.page, this.originals]]);
        const pending = [];
        for (let page = 1; page <= this.config.pages; page++) if (page !== this.config.page) pending.push(page);
        // A small worker pool keeps pagination requests bounded.
        const worker = async () => {
          while (pending.length) {
            const page = pending.shift();
            const url = new URL(window.location.href);
            url.searchParams.set('page', page);
            url.searchParams.set('section_id', this.config.section);
            url.searchParams.delete('ldc_color');
            url.searchParams.delete('ldc_length');
            const response = await fetch(url.href, {credentials: 'same-origin', signal: fetchController.signal});
            if (!response.ok) throw new Error('Catalogue page unavailable');
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const nextGrid = parsed.querySelector('.collection-page__list');
            const nextConfig = parsed.querySelector('[data-ldc-refine-config]');
            if (!nextGrid || !nextConfig || JSON.parse(nextConfig.textContent).page !== page) throw new Error('Unexpected catalogue page');
            pages.set(page, Array.from(nextGrid.querySelectorAll('[data-ldc-card]')));
          }
        };
        await Promise.all([worker(), worker()]);
        if (!this.root.isConnected || this.controller.signal.aborted) return;
        const seen = new Set();
        this.records = [];
        for (const [page, cards] of Array.from(pages.entries()).sort((a, b) => a[0] - b[0])) {
          for (const card of cards) {
            const link = card.querySelector('.product-thumbnail__title');
            if (!link) continue;
            const key = new URL(link.getAttribute('href'), window.location.origin).pathname;
            if (seen.has(key)) continue;
            seen.add(key);
            this.records.push({
              ...ldcFacetValues(card.dataset.ldcColour, card.dataset.ldcLength, card.dataset.ldcTitle, this.config.colourNames),
              node: card, original: page === this.config.page
            });
          }
        }
        this.loaded = true;
        this.readSelection();
        this.populate();
        this.syncControls();
        this.message('', false);
        this.apply(false);
      } catch (_) {
        if (!this.controller.signal.aborted) this.message(this.labels.error, true);
      } finally {
        clearTimeout(timeout);
        this.controller.signal.removeEventListener('abort', abort);
        this.loading = false;
      }
    }
    populate() {
      const colors = new Map();
      const lengths = new Set();
      this.records.forEach(record => {
        if (record.color && (!colors.has(record.color) || record.colourLabel.length > colors.get(record.color).length)) colors.set(record.color, record.colourLabel);
        if (record.length) lengths.add(record.length);
      });
      this.controls.forEach(control => {
        for (const [selector, values] of [
          ['[data-ldc-colour-select]', Array.from(colors.entries()).sort((a, b) => a[0].localeCompare(b[0], undefined, {numeric: true}))],
          ['[data-ldc-length-select]', Array.from(lengths).sort((a, b) => a.localeCompare(b, undefined, {numeric: true})).map(value => [value, value])]
        ]) {
          const select = control.querySelector(selector);
          while (select.options.length > 1) select.remove(1);
          values.forEach(([value, label]) => select.add(new Option(label, value)));
          select.disabled = false;
        }
      });
    }
    syncControls() {
      this.controls.forEach(control => {
        for (const [selector, value] of [['[data-ldc-colour-select]', this.selection.color], ['[data-ldc-length-select]', this.selection.length]]) {
          const select = control.querySelector(selector);
          // Preserve a shared URL's selected facet even when the current collection has no match.
          if (value && !Array.from(select.options).some(option => option.value === value)) select.add(new Option(value, value));
          select.value = value;
        }
      });
    }
    cloneCard(record) {
      const clone = record.node.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      clone.classList.remove('product-thumbnail--has-secondary-media-swap');
      clone.querySelectorAll('[data-quickshop-button], [data-secondary-media], [data-thumbnail-video]').forEach(element => element.remove());
      const imageUrl = clone.dataset.ldcImage;
      const media = clone.querySelector('[data-primary-media]');
      if (imageUrl && media) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = clone.dataset.ldcTitle || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain';
        media.replaceChildren(image);
      }
      clone.hidden = false;
      this.clones.push(clone);
      return clone;
    }
    apply(writeUrl) {
      if (!this.loaded) return;
      this.clones.forEach(card => card.remove());
      this.clones = [];
      const active = Boolean(this.selection.color || this.selection.length);
      this.status.hidden = !active;
      if (this.pagination) this.pagination.hidden = active;
      if (!active) {
        this.originals.forEach(card => {card.hidden = false; this.grid.appendChild(card);});
        this.count.textContent = '';
      } else {
        this.originals.forEach(card => {card.hidden = true;});
        const matched = this.records.filter(record => ldcFacetMatches(record, this.selection));
        matched.forEach(record => {
          const card = record.original ? record.node : this.cloneCard(record);
          card.hidden = false;
          this.grid.appendChild(card);
        });
        this.count.textContent = matched.length ? this.labels.results.replace('__COUNT__', String(matched.length)) : this.labels.empty;
      }
      if (writeUrl) {
        const url = new URL(window.location.href);
        for (const [key, value] of [['ldc_color', this.selection.color], ['ldc_length', this.selection.length]]) {
          if (value) url.searchParams.set(key, value);
          else url.searchParams.delete(key);
        }
        window.history.replaceState(window.history.state, '', url.href);
      }
    }
    destroy() { this.controller.abort(); this.clones.forEach(card => card.remove()); }
  }
  function ldcInitShopping(root = document) {
    const sections = root.matches?.('.collection-page') ? [root] : Array.from(root.querySelectorAll('.collection-page'));
    for (const section of sections) {
      const configNode = section.querySelector('[data-ldc-refine-config]');
      const grid = section.querySelector('.collection-page__list');
      if (!configNode || !grid) continue;
      const previous = ldcRefinements.get(section);
      if (previous?.grid === grid && previous?.configNode === configNode) continue;
      previous?.destroy();
      try { ldcRefinements.set(section, new LdcCatalogueRefinement(section, configNode, grid)); } catch (_) {}
    }
  }
  const ldcStartShopping = () => {
    ldcInitShopping();
    const main = document.querySelector('#main-content');
    if (!main) return;
    let timer;
    new MutationObserver(() => {clearTimeout(timer); timer = setTimeout(() => ldcInitShopping(main), 80);})
      .observe(main, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ldcStartShopping, {once: true});
  else ldcStartShopping();
  document.addEventListener('shopify:section:load', event => ldcInitShopping(event.target));

})();
